import { Link } from "react-router-dom";

export default function ContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        {/* What is CSSBuy Spreadsheet */}
        <article className="mb-20">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
            <div className="lg:w-3/5">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-4">
                Guia Essencial
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                O que &eacute; CSSBuy Spreadsheet?
              </h2>
              <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  O <strong>CSSBuy Spreadsheet</strong> &eacute; uma ferramenta essencial para quem deseja comprar produtos da China com efici&ecirc;ncia e economia. Trata-se de uma planilha organizada que cataloga produtos, pre&ccedil;os, avalia&ccedil;&otilde;es e links diretos, permitindo que voc&ecirc; encontre os melhores itens sem perder horas navegando em f&oacute;runs e cat&aacute;logos dispersos.
                </p>
                <p>
                  Mais do que uma simples lista de produtos, o CSSBuy Spreadsheet funciona como um <strong>hub centralizado de compras</strong>. Cada entrada na planilha inclui informa&ccedil;&otilde;es detalhadas como nome do produto, pre&ccedil;o em yuan, avalia&ccedil;&otilde;es de qualidade, fotos reais dos itens e links diretos para as plataformas chinesas como Taobao, Weidian e 1688.
                </p>
                <p>
                  Para iniciantes no universo de agentes de compras, esta ferramenta elimina a curva de aprendizado. Voc&ecirc; n&atilde;o precisa saber chin&ecirc;s, n&atilde;o precisa pesquisar em f&oacute;runs e n&atilde;o corre o risco de cair em golpes. Tudo o que precisa est&aacute; organizado em uma &uacute;nica interface acess&iacute;vel.
                </p>
              </div>
            </div>
            <div className="lg:w-2/5">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20colorful%20spreadsheet%20data%20on%20screen%20placed%20on%20a%20warm%20oak%20desk%20with%20ceramic%20coffee%20cup%2C%20editorial%20workspace%20photography%2C%20soft%20golden%20morning%20light%20streaming%20from%20window%2C%20visible%20plant%20shadow%20patterns%20on%20desk%2C%20minimalist%20home%20office%20aesthetic%2C%20warm%20terracotta%20and%20sand%20tones%2C%20professional%20yet%20cozy%20atmosphere&width=500&height=450&seq=content-whatis-v3-r6s7&orientation=landscape"
                  alt="CSSBuy Spreadsheet explanation"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </article>

        {/* How it Works */}
        <article className="mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Passo a Passo
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
            Como Funciona o CSSBuy Spreadsheet
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {[
              { step: "01", icon: "ri-file-search-line", title: "Abra a Planilha", desc: "Acesse o CSSBuy Spreadsheet e navegue pelas categorias organizadas de produtos." },
              { step: "02", icon: "ri-shopping-bag-3-line", title: "Escolha o Produto", desc: "Encontre o item desejado, verifique avalia&ccedil;&otilde;es, fotos reais e pre&ccedil;os." },
              { step: "03", icon: "ri-link-m", title: "Copie o Link", desc: "Copie o link direto do produto para a plataforma chinesa de compras." },
              { step: "04", icon: "ri-rocket-line", title: "Use o CSSBuy", desc: "Cole o link no agente CSSBuy, finalize a compra e aguarde a entrega." },
            ].map((item) => (
              <div key={item.step} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </div>
                <span className="text-foreground-300 text-xs font-medium">{item.step}</span>
                <h3 className="text-foreground-950 font-semibold text-base mt-1 mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </article>

        {/* Benefits */}
        <article className="mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Vantagens
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
            Benef&iacute;cios Principais
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {[
              { icon: "ri-money-dollar-circle-line", title: "Economia", desc: "Acesse os menores pre&ccedil;os do mercado com compara&ccedil;&otilde;es diretas entre fornecedores e produtos similares." },
              { icon: "ri-stack-line", title: "Organiza&ccedil;&atilde;o", desc: "Tudo centralizado em uma &uacute;nica planilha. Diga adeus a abas infinitas e informa&ccedil;&otilde;es dispersas." },
              { icon: "ri-flashlight-line", title: "Velocidade", desc: "Encontre produtos em segundos. A interface otimizada reduz drasticamente o tempo de pesquisa." },
            ].map((item) => (
              <div key={item.title} className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                <div className="w-14 h-14 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-accent-600 text-2xl`}></i>
                </div>
                <h3 className="text-foreground-950 font-heading font-semibold text-lg mb-2">{item.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </article>

        {/* Comparison Table */}
        <article>
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            Compara&ccedil;&atilde;o
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">
            CSSBuy Spreadsheet vs Outros M&eacute;todos
          </h2>
          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-background-200/70">
                    <th className="text-left px-6 py-4 text-foreground-900 font-semibold text-sm">M&eacute;todo</th>
                    <th className="text-left px-6 py-4 text-foreground-900 font-semibold text-sm">Facilidade</th>
                    <th className="text-left px-6 py-4 text-foreground-900 font-semibold text-sm">Pre&ccedil;o</th>
                    <th className="text-left px-6 py-4 text-foreground-900 font-semibold text-sm">Efici&ecirc;ncia</th>
                    <th className="text-left px-6 py-4 text-foreground-900 font-semibold text-sm">Seguran&ccedil;a</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="px-6 py-4 text-foreground-900 font-medium text-sm">CSSBuy Spreadsheet</td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                        <i className="ri-checkbox-circle-fill"></i> Alta
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                        <i className="ri-checkbox-circle-fill"></i> Baixo
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                        <i className="ri-checkbox-circle-fill"></i> Alta
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                        <i className="ri-checkbox-circle-fill"></i> Alta
                      </span>
                    </td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="px-6 py-4 text-foreground-700 text-sm">Busca Manual em F&oacute;runs</td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">M&eacute;dia</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">M&eacute;dio</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">Baixa</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">M&eacute;dia</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="px-6 py-4 text-foreground-700 text-sm">Links Diretos sem Curadoria</td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">Baixa</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">Vari&aacute;vel</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-400 text-sm">Baixa</span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-primary-500 text-sm font-medium">
                        <i className="ri-error-warning-fill"></i> Baixa
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </article>

        {/* CTA */}
        <div className="mt-14 text-center">
          <Link
            to="/artigo/o-que-e-cssbuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Ler Guia Completo
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}